import { LoanCaseDTO } from "@smartx/mikro-vt-client-api"
import { useTranslation } from "react-i18next"
import { IField } from "../../../components/DataList/DataList"
import { DataListComponent } from "../../../Shared"

interface OverviewAccountNumbersProps {
  loanCaseData: LoanCaseDTO
}

const OverviewAccountNumbers: React.FC<OverviewAccountNumbersProps> = ({
  loanCaseData,
}) => {
  const { t } = useTranslation()

  const fieldArr: Array<IField> = [
    {
      label: t("case.fields.accountNo"),
      value: loanCaseData.accountNo,
      fieldType: "bankAccount",
    },
    {
      label: t("case.fields.secondaryAccountNo"),
      value: loanCaseData.secondaryAccountNo,
      fieldType: "bankAccount",
    },
  ]

  return (
    <DataListComponent
      dataList={fieldArr}
      noResultText={t("case.overview.warnings.noAccountNumbers")}
    />
  )
}

export default OverviewAccountNumbers
